import React, { useEffect } from 'react';
//import { useAlarmLegend } from '../../hooks/useAlarmLegend';
import ParameterGroup from '../../components/ParameterGroup/ParameterGroup';
//import AlarmLegend from '../../components/AlarmLegend/AlarmLegend';
import './setpoints-manager.scss';
import { Parameter, ParameterGroup as ParameterGroupType } from '../../types/SetpointManagerTypes';
import { Filters, SortingRule } from 'react-table';

interface SetPointsManagerTableProps {
  showBackup: boolean;
  groups: ParameterGroupType[];
  toggleGroupExpansion: (groupId: string) => void;
  updateSortData: (group: string, sortData: SortingRule<Parameter>[]) => void;
  sortData: Record<string, SortingRule<Parameter>[]>;
  updateFilters: (group: string, filters: Filters<Parameter>) => void;
  filters: Record<string, Filters<Parameter>>;
  rPermission: { [key: string]: boolean };
}

const SetPointsManagerTable: React.FC<SetPointsManagerTableProps> = ({
  showBackup,
  groups,
  toggleGroupExpansion,
  updateSortData,
  sortData,
  updateFilters,
  filters,
  rPermission
}) => {
  //const { items: alarmLegendItems, loading: legendLoading, error: legendError } = useAlarmLegend();
  //console.log('SetPointsManagerTable render', groups);

  useEffect(() => {
    // Log the groups when the component mounts or updates
    console.log('SetPointsManagerTable mounted/updated', groups);
  }, [groups]);
  return (
    <div className='parameter-group-parent'>
      <section>
        {groups.map((group) => (
          <ParameterGroup
            key={group.setpointGroup}
            group={group}
            onToggleExpand={toggleGroupExpansion}
            showBackup={showBackup}
            updateSortData={updateSortData}
            sortData={sortData[group.setpointGroupName] || []}
            filters={filters[group.setpointGroupName] || []}
            updateFilters={updateFilters}
            rPermission={rPermission}
          />
        ))}
      </section>
    </div>
  );
};

export default SetPointsManagerTable;
